import { motion } from "framer-motion";
import styled from "styled-components";
import { keyframes, css } from "styled-components";

const inc = keyframes`
 from { left: -5%; width: 5%; }
 to { left: 130%; width: 100%;}
`;
const dec = keyframes`
 from { left: -80%; width: 80%; }
 to { left: 110%; width: 10%;}
`;
const animation = keyframes`
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
`;

const HEIGHT = "3px";
export const Wrap = motion(styled.div`
  pointer-events: none;
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  width: 100%;
  height: ${HEIGHT};
  overflow: hidden;
`);
export const sublineMixin = css`
  position: absolute;
  background: var(--color-progress-bar);
  height: ${HEIGHT};
`;
export const SublineInc = styled.div`
  ${sublineMixin};
  animation: ${inc} 2s infinite;
`;
export const SublineDec = styled.div`
  ${sublineMixin};
  animation: ${dec} 2s 0.5s infinite;
`;
export const Runner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.4;
  background: var(--color-progress-bar);
  animation: ${animation} 1s infinite linear;
  transform-origin: 0% 50%;
`;
